import clsx from 'clsx';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { ButtonWithPopover } from '@/core/ButtonWithPopover.molecule';
import { faCaretDown } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Button } from '@seeqdev/qomponents';
import type { ButtonVariant } from '@seeqdev/qomponents';

export type ButtonWithPopoverAttachedProps = {
  id: string;
  onClick: () => void;
  label: string;
  popoverContent: React.ReactNode;
  showPopover?: boolean;
  popoverIndicator?: React.ReactNode;
  testId?: string;
  disabled?: boolean;
  inProgress?: boolean;
  variant?: ButtonVariant;
  icon?: string;
  iconPrefix?: string;
};

/**
 * A normal button with a popover button (`<ButtonWithPopover />`) attached
 */
export const ButtonWithPopoverAttached = ({
  id,
  label,
  onClick,
  showPopover = true,
  popoverIndicator,
  popoverContent,
  testId = 'buttonWithPopoverAttached',
  disabled,
  inProgress = false,
  variant = 'theme',
  icon,
  iconPrefix,
}: ButtonWithPopoverAttachedProps) => {
  const { t } = useTranslation();

  return (
    <div className="tw:ml-sq-5 tw:inline-flex tw:items-center tw:justify-center" data-testid={testId}>
      <Button
        label={t(label)}
        extraClassNames={clsx('tw:h-sq-30!', {
          noRightRadius: showPopover && popoverContent,
        })}
        onClick={onClick}
        testId={`${testId}Button`}
        disabled={disabled}
        inProgress={inProgress}
        variant={variant}
        icon={icon}
        iconPrefix={iconPrefix}
      />
      {showPopover && popoverContent && (
        <ButtonWithPopover
          popoverConfig={{ id: `${id}Popover`, placement: 'bottom' }}
          label={
            <Button
              variant={variant}
              stopPropagation={false}
              extraClassNames="height-30 mln1 noLeftRadius"
              icon={_.isUndefined(popoverIndicator) ? faCaretDown : undefined}
              iconStyle="white"
              label={popoverIndicator}
              testId={`${testId}PopoverLabel`}
            />
          }>
          {popoverContent}
        </ButtonWithPopover>
      )}
    </div>
  );
};
